import { Outlet } from 'react-router-dom';

import * as St from './Layout.styles';
import { useLayoutNextButtonVisibility } from './hooks/useLayoutNextButtonVisibility';

import NextStepButton from '~atoms/NextStepButton';
import NavStepper from '~molecules/NavStepper';
import Header from '~organisms/Header';
import NavBar from '~organisms/NavBar';

const Layout = () => {
  const shouldShowNextButton = useLayoutNextButtonVisibility();

  return (
    <St.Container>
      <Header>
        <NavBar>
          <NavStepper />
        </NavBar>
      </Header>

      <St.MainContent>
        <Outlet />

        {shouldShowNextButton && (
          <St.NextStepContainer>
            <NextStepButton />
          </St.NextStepContainer>
        )}
      </St.MainContent>
    </St.Container>
  );
};

export default Layout;
